import { GRID_DIMENSIONS } from "@/utils/constants";
import type { SxProps, Theme } from "@mui/material/styles";
import { dataEntryTableStyles } from "../../../../../../shared/styles/dataEntryTableStyles";

/**
 * Calculate dynamic height for Lab tables based on row count
 */
const calculateLabDynamicHeight = (rowCount?: number): string => {
  let count = rowCount ?? 5;
  if (count < 5) {
    count = 5;
  }
  const PADDING = 76;
  const calculatedHeight =
    GRID_DIMENSIONS.HEADER_HEIGHT +
    count * GRID_DIMENSIONS.ROW_HEIGHT +
    PADDING;
  return `${calculatedHeight}px`;
};

/**
 * Table styles for Laboratory Data Entry
 * Extends shared dataEntryTableStyles with Lab-specific overrides and dynamic height support
 */
export const labDETablesStyles = (
  theme: Theme,
  options?: { rowCount?: number },
): Record<string, SxProps<Theme>> => ({
  ...dataEntryTableStyles(theme),
  // Lab-specific overrides
  dynamicHeight: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    padding: "10px 10px 10px 10px",
    height: calculateLabDynamicHeight(options?.rowCount),
  },
});
